import { captureRemixErrorBoundaryError } from "@sentry/remix";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError,
  useLoaderData,
} from "@remix-run/react";
import type { LinksFunction, LoaderFunctionArgs } from "@remix-run/node";
import { data } from "@remix-run/node";
import { toast } from "sonner";
import { useEffect } from "react";

import "./tailwind.css";
import { popToast } from "~/services/toast.server";
import { Toaster } from "~/components/ui/Toaster";
import { PageTransitionProgressBar } from "~/components/progress";
import RouteWrapperWithSidebar from "~/components/RouteWrapperWithSidebar";
import {getAuthenticatedUser} from "~/services/auth.server";

export const links: LinksFunction = () => [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Inter&display=swap",
  },
];

export async function loader({ request }: LoaderFunctionArgs) {
  const { toast, headers } = await popToast(request.headers);
  const user = await getAuthenticatedUser(request);
  console.log(user)
  return data({ toast, user }, { headers });
}

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en" className={'dark'}>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body
          className={'bg-background'}
      >
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export const ErrorBoundary = () => {
  const error = useRouteError();
  captureRemixErrorBoundaryError(error);
  return <div>Something went wrong</div>;
};

export default function App() {
  const { toast: toastData, user } = useLoaderData<typeof loader>();

  useEffect(() => {
    if (toastData) {
      switch (toastData.type) {
        case "success":
          toast.success(toastData.message);
          break;
        case "error":
          toast.error(toastData.message);
          break;
        case "info":
          toast.info(toastData.message);
          break;
        case "warning":
          toast.warning(toastData.message);
      }
    }
  }, [toastData]);

  return (
    <>
      <PageTransitionProgressBar />
      <RouteWrapperWithSidebar user={user}>
        <Outlet />
      </RouteWrapperWithSidebar>
      <Toaster />
    </>
  );
}
